<template>
  <div class="check-list-delete auto-list_col_centered">
    <div class="flex__center">
      <img v-if="response.is_auto_and_driver_and_bid_client_org_already_were_together"
        src="@/assets/img/response-documents.svg"
        style="margin-right: 8px"
        width="32"
      />
      <img
        v-if="
          response.user_org_inn !== '2315190510' &&
          response['user-role'] === 'carrier'
        "
        style="margin-right: 8px"
        src="@/assets/img/mobile-icon.jpg"
        width="32"
        alt=""
      />
      <img
        v-if="[1, 2].includes(getApproveStatus(response))"
        :class="{ not_verified: getApproveStatus(response) === 2 }"
        src="@/assets/img/verification-man.svg"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Verify',
  props: {
    response: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getApproveStatus(r) {
      return r.master_approve_id !== null ? r['master-approve'].status : 0
    },
  },
}
</script>

<style lang="sass">
.not_verified
  filter: invert(40%) grayscale(100%) brightness(55%) sepia(100%) hue-rotate(-50deg) saturate(400%) contrast(2);
</style>
